import React from 'react';
import PropTypes from 'prop-types';
import { IcepackForm } from '../icepack-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { ICEPACK_TABLE_COLUMNS_NAMES } from '../../constants';

export const IcepackModalContent = ({ isLoading, icepackInfo, isIcepackFormOpen }) => {
	if (isIcepackFormOpen) {
		return <IcepackForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={icepackInfo}
			isTableDataLoading={isLoading}
			columns={ICEPACK_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

IcepackModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	icepackInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
				PropTypes.shape({
					length: PropTypes.string,
					width: PropTypes.string,
					height: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isIcepackFormOpen: PropTypes.bool.isRequired,
};
